import HubEpworthQuestionnaireModule from './HubEpworthQuestionnaireModule'

export default HubEpworthQuestionnaireModule
